import React, { useState, useEffect, Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import Loader from "./customers/components/Spinner";
import AuthService from "./customers/services/AuthService";

import { Provider } from "react-redux";
import store from "./customers/reducers/store";
import Head from "./staff/components/Head";
import ConfigProvider from "./customers/config/context.tsx";

import { metricsInit } from "./utils/ym";
import AccessControlProvider from "./AccessControlProvider";

import GTMInit from "./GTMInit";

import { QueryClientProvider, QueryClient } from "react-query";

// TODO: remove jquery from anywhere
import "jquery";
import CustomerService from "./customers/services/CustomerService";
import initStore from "./initStore";
import * as Sentry from "@sentry/react";
import { Route } from "react-router-dom";

metricsInit();

const App = lazy(() => import("./App"));

const SENTRY_DSN = process.env.SENTRY_DSN || "";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

SENTRY_DSN &&
  Sentry.init({
    dsn: SENTRY_DSN
  });

const AppInit = () => {
  const [loading, setLoading] = useState(true);

  AuthService.authenticate();

  if (!AuthService.isAuth()) AuthService.redirectToLogin();
  useEffect(() => {
    CustomerService.getConfig().then(resp => {
      initStore({
        ...resp.body.initial,
        ...resp.body.config
      });

      setLoading(false);
    });
  }, []);

  if (loading) return <Loader />;

  return (
    <Suspense fallback={<Loader />}>
      <Provider store={store}>
        <GTMInit />
        <ConfigProvider>
          <Head />
          <AccessControlProvider>
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
          </AccessControlProvider>
        </ConfigProvider>
      </Provider>
    </Suspense>
  );
};

ReactDOM.render(<AppInit />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
